import {
  ActiveToastProps,
  FixedToastProps,
  ToastStoreType,
} from "types/store/ToastStoreType";
import { create } from "zustand";

const useToastStore = create<ToastStoreType>((set) => ({
  toastCloseTrigger: 0,
  toastInstantClose: false,

  toastMessage: "",
  toastTimeout: 3000,
  toastType: "success",
  toastColor: "normal",
  toastCloseMethod: null,
  toastButton: null,
  toastVisible: false,

  fixedToastMessage: "",
  fixedToastType: "info",
  fixedToastColor: "normal",

  fixedToastButton: null,
  fixedToastVisible: false,
  fixedToastLoadingMessage: "",
  activeToast: ({
    type,
    color,
    message,
    timeout,
    button,
    closeMethod,
  }: ActiveToastProps) => {
    const lines = message.split("\n");
    if (lines.length > 2) {
      message = lines.slice(0, 2).join("\n");
      console.error(
        "Please do not include more than 2 line breaks in your toast."
      );
    }
    set({
      toastMessage: message,
      toastTimeout: timeout,
      toastType: type,
      toastColor: color || "normal",
      toastCloseMethod: closeMethod || null, // 토스트를 닫을 때 실행되어야 하는 함수에 대한 정의입니다.
      toastButton: button || null,
      toastVisible: true,
    });
  },
  activeFixedToast: ({
    message,
    type,
    color,
    button,
    loadingMessage,
  }: FixedToastProps) => {
    set((state) => ({
      ...state,
      fixedToastVisible: true,
      fixedToastMessage: message,
      fixedToastType: type,
      fixedToastColor: color || "normal",
      fixedToastLoadingMessage: loadingMessage || "",
      fixedToastButton: button || null,
    }));
  },
  closeToast: (instant?: boolean) => {
    set((state) => ({
      toastCloseTrigger: state.toastCloseTrigger + 1,
      toastInstantClose: instant || false,
      toastButton: null,
    }));
  },
  closeFixedToast: () => {
    set({ fixedToastVisible: false });
    setTimeout(() => {
      set((state) => ({
        fixedToastMessage: state.fixedToastMessage,
        fixedToastType: state.fixedToastType,
      }));
    }, 500);
  },
  resetToast: () => {
    set({
      toastMessage: "",
      toastTimeout: 3000,
      toastType: "success",
      toastColor: "normal",
      toastButton: null,
      toastVisible: false,
    });
  },
}));

export default useToastStore;
